module.exports = __webpack_public_path__ + "assets/f5668861d51b91a6e26383feb4d6a768.png";